// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\DispatchDashboard\AcknowledgePilotJobOrdersRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// AcknowledgePilotJobOrdersRequestData is the class that AcknowledgePilotJobOrdersRequest serializes to/from
export interface AcknowledgePilotJobOrdersRequestData {
	
	
    PilotJobOrderIds : number[];
}

// AcknowledgePilotJobOrdersRequestOptions is the class which may be passed to the AcknowledgePilotJobOrdersRequest constructor to define optional initial data values
export interface AcknowledgePilotJobOrdersRequestOptions {
	
	
    PilotJobOrderIds? : number[];
}

export class AcknowledgePilotJobOrdersRequest {
	
	
    public PilotJobOrderIds : SDataArray<number>;

    constructor();
    constructor(data : AcknowledgePilotJobOrdersRequestOptions);
    constructor(data: AcknowledgePilotJobOrdersRequestOptions | null = null) {
	    
	    
        this.PilotJobOrderIds = jsonableObservable(SArray<number>(data && data.PilotJobOrderIds !== undefined ? data.PilotJobOrderIds : []));
    }

    static key(obj : AcknowledgePilotJobOrdersRequest) {
        return ;
    }
    
    static dataKey(obj : AcknowledgePilotJobOrdersRequestOptions) {
        return ;
    }

    static update(obj : AcknowledgePilotJobOrdersRequest, data : AcknowledgePilotJobOrdersRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.PilotJobOrderIds !== undefined) obj.PilotJobOrderIds(data.PilotJobOrderIds);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AcknowledgePilotJobOrdersRequest.ts